import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation } from "@angular/core";
import { GridComponent } from "@progress/kendo-angular-grid";
import { NotificationType } from "../../../../../core/services/notification-type";
import { NotificationService } from "../../../../../core/services/notification.service";
import { ContragentProject } from "../../../../../shared/models/contragent/contragent-project";
import { ContragentProjectsService } from "../../../../../shared/services/contragent-projects.service";

@Component({
    selector: 'contragent-projects-grid',
    templateUrl: './contragent-projects-grid.component.html',
    styleUrls: [
        './contragent-projects-grid.component.scss',
        '../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export class ContragentProjectsGridComponent implements OnChanges {

    @ViewChild("projectsGrid") projectsGrid: GridComponent;

    @Input() contragentId: number;
    @Input() agreementId: number;

    @Output() projectsChanged = new EventEmitter<void>();

    projects: ContragentProject[] = [];
    loading: boolean = false;
    dataSaving: boolean = false;

    constructor(
        private contragentProjectsService: ContragentProjectsService,
        private notificationService: NotificationService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.contragentId || changes.agreementId) {
            this.loadProjects();
        }
    }

    createNewProject(): ContragentProject {
        const project = new ContragentProject();
        project.contragentProjectId = 0;
        project.projectName = '';
        project.contragentId = this.contragentId ? +this.contragentId : null;
        project.agreementId = this.agreementId ? +this.agreementId : null;
        return project;
    }

    addNewProject() {
        this.projectsGrid.addRow(this.createNewProject());
    }

    saveProject({ dataItem }: any) {
        if (!this.contragentId) {
            return;
        }

        if (!dataItem.contragentId) {
            dataItem.contragentId = +this.contragentId;
        }

        if (!dataItem.agreementId) {
            if (!this.agreementId) {
                this.notificationService.error({
                    title: 'Не указан договор',
                    message: 'Чтобы сохранить проект, у клиента должен быть активный договор',
                    notificationType: NotificationType.Toast
                });
                return;
            }

            dataItem.agreementId = +this.agreementId;
        }

        this.dataSaving = true;
        if (!dataItem.contragentProjectId) {
            this.contragentProjectsService.create(dataItem).subscribe(() => {
                this.loadProjects();
                this.projectsChanged.emit();
                this.dataSaving = false;
            }, () => {
                this.dataSaving = false;
            });
        } else {
            this.contragentProjectsService.update(dataItem, "Проект обновлен").subscribe(() => {
                this.loadProjects();
                this.projectsChanged.emit();
                this.dataSaving = false;
            }, () => {
                this.dataSaving = false;
            });
        }
    }

    removeProject({ dataItem }: any) {
        this.dataSaving = true;
        this.contragentProjectsService.isUsed(dataItem.contragentProjectId).subscribe(isUsed => {
            if (isUsed) {
                this.notificationService.error({
                    title: 'Ошибка',
                    message: 'Удалить нельзя, так как используется клиентами',
                    notificationType: NotificationType.Toast
                });
                this.dataSaving = false;
                return;
            }

            this.contragentProjectsService.remove(dataItem.contragentProjectId, "Проект", "Проект удален").subscribe(() => {
                this.loadProjects();
                this.projectsChanged.emit();
                this.dataSaving = false;
            }, () => {
                this.dataSaving = false;
            });
        }, () => {
            this.dataSaving = false;
        });
    }

    loadProjects() {
        if (!this.contragentId) {
            this.projects = [];
            this.loading = false;
            return;
        }

        const filters: any[] = [{ field: 'contragentId', operator: 'eq', value: +this.contragentId }];
        if (this.agreementId) {
            filters.push({ field: 'agreementId', operator: 'eq', value: +this.agreementId });
        }

        this.loading = true;
        this.contragentProjectsService.list({
            skip: 0,
            take: null,
            sort: [{ field: "projectName", dir: "asc" }],
            filter: { logic: 'and', filters }
        }).subscribe(result => {
            this.projects = result.data;
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }

    public rowClass() {
        return {
            'cursor-pointer': true
        };
    }
}
